'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = FolderListView;

var _preact = require('preact');

function FolderListView(props) {
  var folders = props.folders.map(function (folder, i) {
    return (0, _preact.h)(
      'div',
      { key: i, onClick: function onClick() {
          return props.openFolder(folder);
        } },
      (0, _preact.h)(
        'a',
        { 'class': 'name' },
        folder.name
      )
    );
  });

  return (0, _preact.h)(
    'div',
    { 'class': 'window' },
    (0, _preact.h)(
      'div',
      { 'class': 'heading' },
      (0, _preact.h)(
        'b',
        null,
        'browser'
      ),
      (0, _preact.h)(
        'div',
        { 'class': 'buttons' },
        (0, _preact.h)(
          'button',
          { onClick: props.initNewFolder },
          '+ folder'
        )
      )
    ),
    (0, _preact.h)(
      'div',
      { 'class': 'folders list' },
      folders
    )
  );
}


//////////////////
// WEBPACK FOOTER
// ./client/components/Browser/Folders/FolderListView.jsx
// module id = 77
// module chunks = 0